import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import TempoDetector from "@/pages/TempoDetector";

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<TempoDetector />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
